import { useEffect, useState } from 'react';
import { getImpersonatedUserId, stopImpersonation } from '../utils/impersonation-session';

/**
 * Thanh cảnh báo khi admin/CTV đang duyệt web bằng phiên "Login as User".
 * Không có thanh này, người dùng quên mình đang ở tài khoản khác rồi đi soạn bài
 * blog -> backend trả 403 vì token là của user thường.
 */
function ImpersonationBanner() {
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const id = getImpersonatedUserId();
        setUserId(id);
        if (!id) return undefined;
        // Đẩy nội dung xuống để banner không che header
        const prev = document.body.style.paddingTop;
        document.body.style.paddingTop = '32px';
        return () => {
            document.body.style.paddingTop = prev;
        };
    }, []);

    if (!userId) return null;

    const exit = () => {
        stopImpersonation();
        // Reload hẳn để Redux/API client nạp lại theo token vừa khôi phục
        window.location.href = '/';
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                background: '#f59e0b',
                color: '#1f2937',
                padding: '6px 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 1px 4px rgba(0,0,0,.2)',
            }}
        >
            <span>Đang xem với tư cách user #{userId}</span>
            <button
                type="button"
                onClick={exit}
                style={{
                    background: '#1f2937',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 4,
                    padding: '3px 10px',
                    fontSize: 12,
                    cursor: 'pointer',
                }}
            >
                Thoát
            </button>
        </div>
    );
}

export default ImpersonationBanner;
